// extracted by mini-css-extract-plugin
module.exports = {"root":"_2hF0lU9S03CqyefjsMEtta","searchParamLabel":"_5WMK3U9-ictrJIimmxFfU","submitSearchButton":"_2FRr-OCD6v1DROmTZSOMLX button success"};